<template>
  <div>
    <div class="m-2">

      <div class="card m-2 shadow">

        <!--cabezera-->
        <div class="card-header">

          <div class="d-flex">
            <div class="flex-fill">
              <KarinSearch></KarinSearch>
            </div>

            <div class="float-end">
              <KarinPagination></KarinPagination>
            </div>

          </div>

        </div>

        <!--cuerpo-->
        <div class="card-body">

          <KarinTable></KarinTable>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import KarinTable from "@/components/KarinLaw/KarinList/Karin-table.vue";
import KarinPagination from "./KarinList/Karin-pagination.vue";
import KarinSearch from './KarinList/Karin-search.vue'

export default {
  name: 'KarinList',

  components:{
    KarinTable,
    KarinPagination,
    KarinSearch,
  }

}
</script>
<style></style>
